import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import HomeAssessmentPage from './pages/HomeAssessmentPage';
import BusinessAssessmentPage from './pages/BusinessAssessmentPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import CodeOfConductPage from './pages/CodeOfConductPage';
import CollegesPage from './pages/CollegesPage';
import ApplyPage from './pages/ApplyPage';
import BookingPage from './pages/BookingPage';
import InternDashboard from './pages/InternDashboard';
import ClientDashboard from './pages/ClientDashboard';
import ExpertDashboard from './pages/ExpertDashboard';

function ExternalRedirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/careers" element={<ExternalRedirect to="https://students.cyberwisecorp.com" />} />
        <Route path="/home-assessment" element={<HomeAssessmentPage />} />
        <Route path="/business-assessment" element={<BusinessAssessmentPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
        <Route path="/colleges" element={<CollegesPage />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/intern/*" element={<InternDashboard />} />
        <Route path="/client/*" element={<ClientDashboard />} />
        <Route path="/expert/*" element={<ExpertDashboard />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
